/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_Events_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to edit and cancel events." |
*
* @param {Leveling_Perm_Manage_Events_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_events_hint = /** @type {((inputs?: Leveling_Perm_Manage_Events_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_Events_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам изменять и отменять события.")
	return /** @type {LocalizedString} */ ("Allows members to edit and cancel events.")
});